











// // src/BetaSignupPage.jsx
// import React, { useState } from 'react';
// import { getPalette } from './ColorPalette';
// import bannerImage from './images/banner.png';
// import backdropImage from './images/BackdropNight_expanded.png';
// import ApiService from './ApiService';

// // Instantiate the API service
// const apiService = new ApiService();

// // --- Sub-Components ---

// // 1. Choice Chip
// const ChoiceChip = ({ label, selected, onClick, colors }) => (
//   <button
//     type="button"
//     onClick={onClick}
//     style={{
//       padding: '10px 16px',
//       borderRadius: '999px',
//       fontSize: '14px',
//       fontWeight: selected ? 600 : 500,
//       cursor: 'pointer',
//       border: `1px solid ${selected ? colors.tagAccent : colors.border}`,
//       backgroundColor: selected ? `${colors.tagAccent}20` : 'transparent',
//       color: selected ? colors.tagAccent : colors.textMuted,
//       transition: 'all 0.2s ease',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       boxShadow: selected ? `0 0 12px ${colors.tagAccent}40` : 'none',
//     }}
//   >
//     {/* Show a subtle checkmark if selected */}
//     {selected && <span>✓</span>}
//     {label}
//   </button>
// );

// // 2. Selectable Card
// const SelectableCard = ({ label, subLabel, selected, onClick, colors }) => (
//   <button
//     type="button"
//     onClick={onClick}
//     style={{
//       width: '100%',
//       textAlign: 'left',
//       padding: '16px',
//       borderRadius: '12px',
//       cursor: 'pointer',
//       border: `1px solid ${selected ? colors.ctaPrimary : colors.border}`,
//       backgroundColor: selected ? `${colors.ctaPrimary}15` : `${colors.background}80`,
//       transition: 'all 0.2s ease',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       marginBottom: '8px',
//     }}
//   >
//     <div
//       style={{
//         width: '20px',
//         height: '20px',
//         borderRadius: '50%',
//         border: `2px solid ${selected ? colors.ctaPrimary : colors.textMuted}`,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         flexShrink: 0,
//       }}
//     >
//       {selected && (
//         <div
//           style={{
//             width: '10px',
//             height: '10px',
//             borderRadius: '50%',
//             backgroundColor: colors.ctaPrimary,
//           }}
//         />
//       )}
//     </div>
    
//     <div style={{ display: 'flex', flexDirection: 'column' }}>
//       <span
//         style={{
//           fontSize: '15px',
//           fontWeight: selected ? 700 : 500,
//           color: selected ? colors.text : colors.text,
//         }}
//       >
//         {label}
//       </span>
//       {subLabel && (
//         <span style={{ fontSize: '13px', color: colors.textMuted, marginTop: '2px' }}>
//           {subLabel}
//         </span>
//       )}
//     </div>
//   </button>
// );

// const BetaSignupForm = ({ colors }) => {
//   const [email, setEmail] = useState('');
  
//   // CHANGED: State is now a single string, initialized to empty
//   const [platform, setPlatform] = useState(''); 
  
//   const [learnerType, setLearnerType] = useState('');
//   const [learnerTypeOther, setLearnerTypeOther] = useState('');
//   const [level, setLevel] = useState('');
//   const [submitting, setSubmitting] = useState(false);
//   const [statusMessage, setStatusMessage] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage(null);

//     // Basic Validation
//     if (!email.trim()) {
//       setStatusMessage({ type: 'error', text: 'Please enter your email so we can contact you.' });
//       return;
//     }
//     // CHANGED: Validate single string existence
//     if (!platform) {
//       setStatusMessage({ type: 'error', text: 'Please choose your preferred platform.' });
//       return;
//     }
//     if (!learnerType) {
//       setStatusMessage({ type: 'error', text: 'Please choose your learner type.' });
//       return;
//     }
//     if (learnerType === 'other' && !learnerTypeOther.trim()) {
//       setStatusMessage({ type: 'error', text: 'Please tell us a bit more in the "Other" field.' });
//       return;
//     }
//     if (!level) {
//       setStatusMessage({ type: 'error', text: 'Please choose your current Korean level.' });
//       return;
//     }

//     const payload = {
//       email: email.trim(),
//       platform, // CHANGED: Sending single string
//       learnerType: learnerType === 'other' ? learnerTypeOther.trim() : learnerType,
//       level,
//       submittedAt: new Date().toISOString()
//     };

//     setSubmitting(true);

//     try {
//       await apiService.submitBetaSignup(payload);
      
//       setStatusMessage({
//         type: 'success',
//         text: "You're on the list! We'll email you as soon as a beta slot opens up."
//       });
      
//       // Clear form on success
//       setEmail('');
//       setPlatform(''); // CHANGED: Reset string
//       setLearnerType('');
//       setLearnerTypeOther('');
//       setLevel('');
      
//     } catch (error) {
//       console.error('Beta signup error:', error);
//       setStatusMessage({
//         type: 'error',
//         text: 'Something went wrong. Please try again or email us directly at flashfluencydev@gmail.com'
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <section
//       id="beta-signup"
//       style={{
//         padding: '40px 32px',
//         borderRadius: '24px',
//         backgroundColor: colors.container,
//         boxShadow: `0 8px 32px ${colors.shadow}`,
//         border: `1px solid ${colors.border}`,
//       }}
//     >
//       <h2
//         style={{
//           fontSize: '26px',
//           fontWeight: 800,
//           color: colors.text,
//           marginBottom: '12px',
//           textAlign: 'center'
//         }}
//       >
//         Join our Beta Waitlist
//       </h2>
      

//       <form
//         onSubmit={handleSubmit}
//         style={{
//           maxWidth: '600px',
//           margin: '0 auto',
//           display: 'flex',
//           flexDirection: 'column',
//           gap: '32px'
//         }}
//       >
//         {/* 1. Email Section */}
//         <div>
//           <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
//             Email Address
//           </label>
//           <input
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             placeholder="you@example.com"
//             style={{
//               width: '100%',
//               padding: '14px 16px',
//               borderRadius: '12px',
//               border: `1px solid ${colors.border}`,
//               backgroundColor: colors.background,
//               color: colors.text,
//               fontSize: '16px',
//               outline: 'none',
//               transition: 'border 0.2s',
//             }}
//             onFocus={(e) => (e.target.style.borderColor = colors.ctaPrimary)}
//             onBlur={(e) => (e.target.style.borderColor = colors.border)}
//           />
//         </div>

//         {/* 2. Platform Section (Single Select) */}
//         <div>
//           <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
//             Preferred Platform
//           </label>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
//             {[
//               { id: 'ios', label: 'iOS' },
//               { id: 'android', label: 'Android (Google Play Store)' },
//               { id: 'web', label: 'Web Browser' }
//             ].map((opt) => (
//               <ChoiceChip
//                 key={opt.id}
//                 label={opt.label}
//                 // CHANGED: Compare single string equality
//                 selected={platform === opt.id}
//                 // CHANGED: Set single string
//                 onClick={() => setPlatform(opt.id)}
//                 colors={colors}
//               />
//             ))}
//           </div>
//         </div>

//         {/* 3. Learner Type (Single Select) */}
//         <div>
//           <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
//             What describes you best?
//           </label>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
//             {[
//               { id: 'k_culture_enthusiast', label: 'K-Pop / Drama Fan' },
//               { id: 'casual_traveler', label: 'Traveler' },
//               { id: 'professional_expat', label: 'Expat / Working in Korea' },
//               { id: 'heritage_learner', label: 'Heritage Learner' },
//               { id: 'academic', label: 'Student / Academic' },
//               { id: 'other', label: 'Other' }
//             ].map((opt) => (
//               <ChoiceChip
//                 key={opt.id}
//                 label={opt.label}
//                 selected={learnerType === opt.id}
//                 onClick={() => setLearnerType(opt.id)}
//                 colors={colors}
//               />
//             ))}
//           </div>
          
//           <div 
//              style={{ 
//                height: learnerType === 'other' ? 'auto' : '0', 
//                overflow: 'hidden',
//                transition: 'all 0.3s ease'
//              }}
//           >
//             <input
//               type="text"
//               value={learnerTypeOther}
//               onChange={(e) => setLearnerTypeOther(e.target.value)}
//               placeholder="Tell us more..."
//               style={{
//                 width: '100%',
//                 padding: '12px',
//                 borderRadius: '10px',
//                 border: `1px solid ${colors.border}`,
//                 backgroundColor: colors.background,
//                 color: colors.text,
//                 fontSize: '14px'
//               }}
//             />
//           </div>
//         </div>

//         {/* 4. Level (Single Select) */}
//         <div>
//           <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '12px' }}>
//             Where are you starting from?
//           </label>
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             {[
//               { id: 'hangul', label: 'Absolute Beginner', sub: 'I need to learn the alphabet (Hangul)' },
//               { id: 'foundations', label: 'Foundations', sub: 'I know Hangul, but need basic grammar & vocab' },
//               { id: 'beginner', label: 'Beginner', sub: 'Can form basic sentences (≈ 50–1000 vocab)' },
//               { id: 'intermediate', label: 'Intermediate', sub: 'Conversational (≈ 1000–3000 vocab)' },
//               { id: 'advanced', label: 'Advanced', sub: 'Fluid / Native-like (≈ 3000+ vocab)' }
//             ].map((opt) => (
//               <SelectableCard
//                 key={opt.id}
//                 label={opt.label}
//                 subLabel={opt.sub}
//                 selected={level === opt.id}
//                 onClick={() => setLevel(opt.id)}
//                 colors={colors}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Status Messages */}
//         {statusMessage && (
//           <div
//             style={{
//               padding: '14px',
//               borderRadius: '8px',
//               backgroundColor: statusMessage.type === 'success' ? `${colors.tagAccent}15` : 'rgba(255, 100, 100, 0.15)',
//               border: `1px solid ${statusMessage.type === 'success' ? colors.tagAccent : '#ff6464'}`,
//               color: statusMessage.type === 'success' ? colors.tagAccent : '#ff9b9b',
//               fontSize: '14px',
//               textAlign: 'center',
//               fontWeight: 600
//             }}
//           >
//             {statusMessage.text}
//           </div>
//         )}

//         {/* Submit Button */}
//         <div style={{ marginTop: '16px' }}>
//           <button
//             type="submit"
//             disabled={submitting || (statusMessage && statusMessage.type === 'success')}
//             style={{
//               width: '100%',
//               padding: '16px',
//               borderRadius: '999px',
//               border: 'none',
//               backgroundColor: submitting ? colors.border : colors.ctaPrimary,
//               color: '#fff',
//               fontSize: '16px',
//               fontWeight: 700,
//               cursor: submitting ? 'wait' : 'pointer',
//               boxShadow: submitting ? 'none' : `0 4px 12px ${colors.ctaPrimary}60`,
//               transition: 'all 0.2s',
//               transform: submitting ? 'scale(0.98)' : 'scale(1)',
//             }}
//           >
//             {submitting ? 'Submitting...' : 'Request Access'}
//           </button>
//         </div>
//       </form>
//     </section>
//   );
// };

// const BetaSignupPage = () => {
//   const colors = getPalette('dark');

//   return (
//     <div
//       style={{
//         minHeight: '100vh',
//         backgroundImage: `url(${backdropImage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         backgroundRepeat: 'no-repeat',
//         backgroundAttachment: 'fixed',
//         backgroundColor: colors.background,
//         display: 'flex',
//         flexDirection: 'column'
//       }}
//     >
//       {/* Simple nav header */}
//       <nav
//         style={{
//           width: '100%',
//           backgroundColor: `${colors.container}dd`,
//           backdropFilter: 'blur(10px)',
//           boxShadow: `0 2px 8px ${colors.shadow}`,
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 50,
//           borderBottom: `1px solid ${colors.border}`
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1024px',
//             margin: '0 auto',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             padding: '12px 16px'
//           }}
//         >
//           <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
//             <img
//               src={bannerImage}
//               alt="Flash Fluency Banner"
//               style={{ height: '64px', objectFit: 'contain' }}
//             />
//           </a>
          
//           <a
//             href="/"
//             style={{
//               fontSize: '14px',
//               fontWeight: 600,
//               color: colors.text,
//               textDecoration: 'none',
//               padding: '8px 16px',
//               borderRadius: '8px',
//               transition: 'background-color 0.2s'
//             }}
//             className="hover:bg-white/10"
//           >
//             ← Back to Home
//           </a>
//         </div>
//       </nav>

//       <main
//         style={{
//           flexGrow: 1,
//           maxWidth: '1024px',
//           width: '100%',
//           padding: '120px 24px 40px',
//           margin: '0 auto'
//         }}
//       >
//         <BetaSignupForm colors={colors} />
//       </main>
//     </div>
//   );
// };

// export default BetaSignupPage;























// src/BetaSignupPage.jsx
import React, { useState } from 'react';
import { getPalette } from './ColorPalette';
import bannerImage from './images/banner.png';
import backdropImage from './images/BackdropNight_expanded.png';
import ApiService from './ApiService';

// Instantiate the API service
const apiService = new ApiService();

// --- Sub-Components ---

// 1. Choice Chip
const ChoiceChip = ({ label, selected, onClick, colors }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      padding: '10px 16px',
      borderRadius: '999px',
      fontSize: '14px',
      fontWeight: selected ? 600 : 500,
      cursor: 'pointer',
      border: `1px solid ${selected ? colors.tagAccent : colors.border}`,
      backgroundColor: selected ? `${colors.tagAccent}20` : 'transparent',
      color: selected ? colors.tagAccent : colors.textMuted,
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      boxShadow: selected ? `0 0 12px ${colors.tagAccent}40` : 'none',
    }}
  >
    {/* Show a subtle checkmark if selected */}
    {selected && <span>✓</span>}
    {label}
  </button>
);

// 2. Selectable Card
const SelectableCard = ({ label, subLabel, selected, onClick, colors }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      width: '100%',
      textAlign: 'left',
      padding: '16px',
      borderRadius: '12px',
      cursor: 'pointer',
      border: `1px solid ${selected ? colors.ctaPrimary : colors.border}`,
      backgroundColor: selected ? `${colors.ctaPrimary}15` : `${colors.background}80`,
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '8px',
    }}
  >
    <div
      style={{
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: `2px solid ${selected ? colors.ctaPrimary : colors.textMuted}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {selected && (
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: colors.ctaPrimary,
          }}
        />
      )}
    </div>
    
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span
        style={{
          fontSize: '15px',
          fontWeight: selected ? 700 : 500,
          color: selected ? colors.text : colors.text,
        }}
      >
        {label}
      </span>
      {subLabel && (
        <span style={{ fontSize: '13px', color: colors.textMuted, marginTop: '2px' }}>
          {subLabel}
        </span>
      )}
    </div>
  </button>
);

const BetaSignupForm = ({ colors }) => {
  const [email, setEmail] = useState('');
  const [platform, setPlatform] = useState(''); 
  const [learnerType, setLearnerType] = useState('');
  const [learnerTypeOther, setLearnerTypeOther] = useState('');
  const [level, setLevel] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage(null);

    // Email Validation - require Gmail
    if (!email.trim()) {
      setStatusMessage({ type: 'error', text: 'Please enter your Gmail address so we can contact you.' });
      return;
    }
    if (!email.trim().toLowerCase().endsWith('@gmail.com')) {
      setStatusMessage({ type: 'error', text: 'Please use a Gmail address — we use Google Sign-In for the beta.' });
      return;
    }

    if (!platform) {
      setStatusMessage({ type: 'error', text: 'Please choose your preferred platform.' });
      return;
    }
    if (!learnerType) {
      setStatusMessage({ type: 'error', text: 'Please choose your learner type.' });
      return;
    }
    if (learnerType === 'other' && !learnerTypeOther.trim()) {
      setStatusMessage({ type: 'error', text: 'Please tell us a bit more in the "Other" field.' });
      return;
    }
    if (!level) {
      setStatusMessage({ type: 'error', text: 'Please choose your current Korean level.' });
      return;
    }

    const payload = {
      email: email.trim().toLowerCase(),
      platform,
      learnerType: learnerType === 'other' ? learnerTypeOther.trim() : learnerType,
      level,
      submittedAt: new Date().toISOString()
    };

    setSubmitting(true);

    try {
      await apiService.submitBetaSignup(payload);
      
      setStatusMessage({
        type: 'success',
        text: "You're on the list! We'll email you as soon as a beta slot opens up."
      });
      
      // Clear form on success
      setEmail('');
      setPlatform('');
      setLearnerType('');
      setLearnerTypeOther('');
      setLevel('');
      
    } catch (error) {
      console.error('Beta signup error:', error);
      setStatusMessage({
        type: 'error',
        text: 'Something went wrong. Please try again or email us directly at flashfluencydev@gmail.com'
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="beta-signup"
      style={{
        padding: '40px 32px',
        borderRadius: '24px',
        backgroundColor: colors.container,
        boxShadow: `0 8px 32px ${colors.shadow}`,
        border: `1px solid ${colors.border}`,
      }}
    >
      <h2
        style={{
          fontSize: '26px',
          fontWeight: 800,
          color: colors.text,
          marginBottom: '12px',
          textAlign: 'center'
        }}
      >
        Join our Beta Waitlist
      </h2>
      

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px'
        }}
      >
        {/* 1. Email Section */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
            Gmail Address
            <span style={{ fontWeight: 400, color: colors.textMuted, marginLeft: '8px', fontSize: '13px' }}>
              (used for Google Sign-In)
            </span>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@gmail.com"
            style={{
              width: '100%',
              padding: '14px 16px',
              borderRadius: '12px',
              border: `1px solid ${colors.border}`,
              backgroundColor: colors.background,
              color: colors.text,
              fontSize: '16px',
              outline: 'none',
              transition: 'border 0.2s',
            }}
            onFocus={(e) => (e.target.style.borderColor = colors.ctaPrimary)}
            onBlur={(e) => (e.target.style.borderColor = colors.border)}
          />
        </div>

        {/* 2. Platform Section (Single Select) */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
            Preferred Platform
          </label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {[
              { id: 'ios', label: 'iOS' },
              { id: 'android', label: 'Android (Google Play Store)' },
              { id: 'web', label: 'Web Browser' }
            ].map((opt) => (
              <ChoiceChip
                key={opt.id}
                label={opt.label}
                selected={platform === opt.id}
                onClick={() => setPlatform(opt.id)}
                colors={colors}
              />
            ))}
          </div>
        </div>

        {/* 3. Learner Type (Single Select) */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '8px' }}>
            What describes you best?
          </label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
            {[
              { id: 'k_culture_enthusiast', label: 'K-Pop / Drama Fan' },
              { id: 'casual_traveler', label: 'Traveler' },
              { id: 'professional_expat', label: 'Expat / Working in Korea' },
              { id: 'heritage_learner', label: 'Heritage Learner' },
              { id: 'academic', label: 'Student / Academic' },
              { id: 'other', label: 'Other' }
            ].map((opt) => (
              <ChoiceChip
                key={opt.id}
                label={opt.label}
                selected={learnerType === opt.id}
                onClick={() => setLearnerType(opt.id)}
                colors={colors}
              />
            ))}
          </div>
          
          <div 
             style={{ 
               height: learnerType === 'other' ? 'auto' : '0', 
               overflow: 'hidden',
               transition: 'all 0.3s ease'
             }}
          >
            <input
              type="text"
              value={learnerTypeOther}
              onChange={(e) => setLearnerTypeOther(e.target.value)}
              placeholder="Tell us more..."
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '10px',
                border: `1px solid ${colors.border}`,
                backgroundColor: colors.background,
                color: colors.text,
                fontSize: '14px'
              }}
            />
          </div>
        </div>

        {/* 4. Level (Single Select) */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, color: colors.text, marginBottom: '12px' }}>
            Where are you starting from?
          </label>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {[
              { id: 'hangul', label: 'Absolute Beginner', sub: 'I need to learn the alphabet (Hangul)' },
              { id: 'foundations', label: 'Foundations', sub: 'I know Hangul, but need basic grammar & vocab' },
              { id: 'beginner', label: 'Beginner', sub: 'Can form basic sentences (≈ 50–1000 vocab)' },
              { id: 'intermediate', label: 'Intermediate', sub: 'Conversational (≈ 1000–3000 vocab)' },
              { id: 'advanced', label: 'Advanced', sub: 'Fluid / Native-like (≈ 3000+ vocab)' }
            ].map((opt) => (
              <SelectableCard
                key={opt.id}
                label={opt.label}
                subLabel={opt.sub}
                selected={level === opt.id}
                onClick={() => setLevel(opt.id)}
                colors={colors}
              />
            ))}
          </div>
        </div>

        {/* Status Messages */}
        {statusMessage && (
          <div
            style={{
              padding: '14px',
              borderRadius: '8px',
              backgroundColor: statusMessage.type === 'success' ? `${colors.tagAccent}15` : 'rgba(255, 100, 100, 0.15)',
              border: `1px solid ${statusMessage.type === 'success' ? colors.tagAccent : '#ff6464'}`,
              color: statusMessage.type === 'success' ? colors.tagAccent : '#ff9b9b',
              fontSize: '14px',
              textAlign: 'center',
              fontWeight: 600
            }}
          >
            {statusMessage.text}
          </div>
        )}

        {/* Submit Button */}
        <div style={{ marginTop: '16px' }}>
          <button
            type="submit"
            disabled={submitting || (statusMessage && statusMessage.type === 'success')}
            style={{
              width: '100%',
              padding: '16px',
              borderRadius: '999px',
              border: 'none',
              backgroundColor: submitting ? colors.border : colors.ctaPrimary,
              color: '#fff',
              fontSize: '16px',
              fontWeight: 700,
              cursor: submitting ? 'wait' : 'pointer',
              boxShadow: submitting ? 'none' : `0 4px 12px ${colors.ctaPrimary}60`,
              transition: 'all 0.2s',
              transform: submitting ? 'scale(0.98)' : 'scale(1)',
            }}
          >
            {submitting ? 'Submitting...' : 'Request Access'}
          </button>
        </div>
      </form>
    </section>
  );
};

const BetaSignupPage = () => {
  const colors = getPalette('dark');

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backdropImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: colors.background,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Simple nav header */}
      <nav
        style={{
          width: '100%',
          backgroundColor: `${colors.container}dd`,
          backdropFilter: 'blur(10px)',
          boxShadow: `0 2px 8px ${colors.shadow}`,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          borderBottom: `1px solid ${colors.border}`
        }}
      >
        <div
          style={{
            maxWidth: '1024px',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px'
          }}
        >
          <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={bannerImage}
              alt="Flash Fluency Banner"
              style={{ height: '64px', objectFit: 'contain' }}
            />
          </a>
          
          <a
            href="/"
            style={{
              fontSize: '14px',
              fontWeight: 600,
              color: colors.text,
              textDecoration: 'none',
              padding: '8px 16px',
              borderRadius: '8px',
              transition: 'background-color 0.2s'
            }}
            className="hover:bg-white/10"
          >
            ← Back to Home
          </a>
        </div>
      </nav>

      <main
        style={{
          flexGrow: 1,
          maxWidth: '1024px',
          width: '100%',
          padding: '120px 24px 40px',
          margin: '0 auto'
        }}
      >
        <BetaSignupForm colors={colors} />
      </main>
    </div>
  );
};

export default BetaSignupPage;